import { render, staticRenderFns } from "./AddFieldItem.vue?vue&type=template&id=014bf2b7&"
import script from "./AddFieldItem.vue?vue&type=script&lang=ts&"
export * from "./AddFieldItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports